<template>
  <div
    id="app"
    class="fill-height"
  >
    <the-app-loader v-if="loading" />
    <router-view v-else />
    <noscript>Please enable JavaScript to use this app</noscript>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TheAppLoader from '@/components/layout/TheAppLoader'

export default {
  name: 'App',
  components: {
    TheAppLoader
  },
  computed: {
    ...mapState([ 'loading' ])
  },
  mounted () {
    this.$store.dispatch('doFirstLoad')
  }
}
</script>
<style lang="scss">
.list.list--scrollable {
  max-height: 300px;
  overflow-y: auto;
}
</style>
